import { map, split } from 'lodash-es'

const splitCsvToNumberArray = csv => map(split(csv, ','), v => Number(v))

export default splitCsvToNumberArray
